import { Enum, EnumWithDefault, KeyValuePair } from './base';

export class CompanyLocalTaxConfig {
  LocalTypeId: number;
  StateAbbreviation: string;
  TaxType: string;
  PaidBy: string;
  IsRequired: boolean;
  IsSelectByCountyAvailable: boolean;
  RequiresTaxElections: boolean;
  TaxLabel: string;
  MatchesOn: number;
  ExcludeFrom: number;
  Instructions: string;
  StateURL: string;
  TaxCodes: KeyValuePair[];
  FilingStatuses: LocalTaxFilingStatus[];
  UsesStateFilingStatus: boolean; // US 7112
}

export class CompanyTaxCodeConfig {
  TaxCode: string;
  TaxType: string; // "I" = Income, "U" = Unemployment
  DisplayName: string;
  EntityType: string;
  WithholdingTypes: Enum[];
  FilingStatuses: EnumWithDefault[];
  CanHaveAdditionalAllowances: boolean;
  MaxAllowedAllowances: number;
  MaxAllowedAddlAllowances: number;
  IsActive: boolean;
  IsIncomeWithholdingState: boolean;
  StateAbbreviation: string;

  constructor(
    code: string,
    type: string,
    name: string,
    entityType: string,
    wTypes: Enum[],
    filingStatuses: EnumWithDefault[],
    canHaveAddlAllow: boolean,
    maxAllow: number,
    maxAddlAllow: number,
    isActive: boolean,
    isIncomeWithholdingState: boolean,
    stateAbbreviation: string
  ) {
    this.TaxCode = code;
    this.TaxType = type;
    this.DisplayName = name;
    this.EntityType = entityType;
    this.WithholdingTypes = wTypes;
    this.FilingStatuses = filingStatuses;
    this.CanHaveAdditionalAllowances = canHaveAddlAllow;
    this.MaxAllowedAllowances = maxAllow;
    this.MaxAllowedAddlAllowances = maxAddlAllow;
    this.IsActive = isActive;
    this.IsIncomeWithholdingState = isIncomeWithholdingState;
    this.StateAbbreviation = stateAbbreviation;
  }
}

export class SchoolDistrict {
  SchoolCodeName: string;
  ResidentTaxCode: string;
  ResidentTaxName: string;
}

export class LocalTaxFilingStatus {
  Id: string;
  Value: string;
  IsDefault: boolean;
  TaxCode: string;
}
